import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import "./Promo.scss";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';import { ReactComponent as Check } from "../../assets/new-icons/check_simple.svg";
import { ReactComponent as Close } from "../../assets/new-icons/close.svg";
import { ReactComponent as Icon3 } from "../../assets/new-icons/ricarica3Icon.svg";
import { ReactComponent as Icon6 } from "../../assets/new-icons/ricarica6Icon.svg";
import { ReactComponent as Icon12 } from "../../assets/new-icons/ricarica12Icon.svg";

import { ReactComponent as Alert } from "../../assets/new-icons/alert.svg";
import { ReactComponent as Plus } from "../../assets/new-icons/plus.svg";
import PayMethod from "../../components/profilo/ListaPods/PayMethod";
import axios from "axios";
import { useSelector } from "react-redux";
import md5 from "md5";
import { setPath } from "../../features/settingSlice";
import { useDispatch } from "react-redux";
import CircularProgress from '@mui/material/CircularProgress';
import NewHeader from "../../components/New Header/NewHeader";
import Conferma from "../../components/Conferma/Conferma";
import AlertNotice from "../../components/AlertNotice/AlertNotice";

function Promo() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [disable, setDisable] = useState(false)
  const [overlay, setOverlay] = useState(false);
  const [detail, setDetail] = useState();
  const [navigation, setNavigation] = useState(true);
  const [rateizza, setRateizza] = useState(false);
  const [price, setPrice] = useState();
  const priceDecimal3 = price && price.ricarica3.toString().split('.')
  const priceDecimal6 = price && price.ricarica6.toString().split('.')
  const priceDecimal12 = price && price.ricarica12.toString().split('.')
  const [seeConferma, setSeeConferma] = useState(false)
  const customerCode = useSelector((user) => user.user.info.customer_code);
  const customerId = useSelector((user) => user.user.info.customer_id);
  const tkn = md5(customerId + "oYmAIdtki%lu");
  const podCode = useSelector((user) => user.user.info.pod_code);
  let token = useSelector((user) => user.user.datiPagamento.token);
  token = token && token.replace(/\s/g, '')

  const defaultMethod = useSelector(
    (user) => user.user.datiPagamento.method_name
  );
  const prenotazioneEffettuata = useSelector(
    (user) => user.settings.ricarica3612Effettuata
  );
    console.log(token)
  useEffect(() => {
    window.scrollTo(0, 0)
    document.querySelector('.promo-bottom').scrollTo(0,0);
    document.body.style.overflow ="hidden";
    document.body.style.touchAction = "none";
    init();
  }, [overlay]);
  const init = async () => {
    const urlValori = `https://my.revoluce.it/area_utente/gestione/api/promo/3612.php?customer_id=${customerId}&customer_code=${customerCode}&tkn_pvt=${tkn}`;
    const { data } = await axios.get(urlValori);
    setPrice(data.result);
  };
  const data = [
    {
      icon: <Icon3 />,
      months: "3",
      description: "Equivalenti al tuo consumo medio per 3 mesi.",
      bonusEuro: 3,
      bonusPercentuale: 0.15,
      price: priceDecimal3,
      gradient:
        "transparent linear-gradient(64deg, #FFFFFF 0%, #C5D0E2 100%) 0% 0% no-repeat padding-box",
      gradientIcon:
        "linear-gradient(328deg, rgb(203 213 229) 0%, rgb(239 240 241) 65%)",
      rateizzabile: false,
    },
    {
      icon: <Icon6 />,
      months: "6",
      description: "Equivalenti al tuo consumo medio per 6 mesi.",
      bonusEuro: 9,
      bonusPercentuale: 0.2,
      bonusPercentualeRatio: 0.15,
      price: priceDecimal6,
      gradient:
        "transparent linear-gradient(62deg, #FFFFFF 0%, #A8B3B3 100%) 0% 0% no-repeat padding-box",
      gradientIcon:
        "linear-gradient(328deg, rgb(184 193 193) 0%, rgb(247 248 248) 65%)",
      rateizzabile: true,
      diviso: 5,
    },
    {
      icon: <Icon12 />,
      months: "12",
      description: "Equivalenti al tuo consumo medio per 12 mesi.",
      bonusEuro: 18,
      bonusPercentuale: 0.3,
      bonusPercentualeRatio: 0.2,
      price: priceDecimal12,
      gradient:
        "transparent linear-gradient(64deg, #FFFFFF 0%, #4D4D4D 100%) 0% 0% no-repeat padding-box",
      gradientIcon:
        "linear-gradient(328deg, rgba(77,77,77,1) 0%, rgba(246,247,247,1) 65%)",
      rateizzabile: true,
      diviso: 10,
    },
  ];
  const handleDetail = (r) => {
    setOverlay(!overlay);
    setNavigation(!navigation);
    setDetail(r);
  };
  const switchMonths = () => {
    switch (detail.months) {
      case "6":
        return "5";
      case "12":
        return "10";
      default:
        break;
    }
  };
  const payPromo = async () => {
    if(defaultMethod === "RID" && !prenotazioneEffettuata){ // prima opzione
      setDisable(!disable)
      setSeeConferma(false)
      dispatch(setPath(location.pathname));

      const urlPaga = `https://my.revoluce.it/sella/pagaPromoApp.php?amount=${
        rateizza
          ? parseFloat(detail.price / detail.diviso).toFixed(2)
          : parseFloat(detail.price).toFixed(2)
      }&token=${token}&customer=${customerId}&tipo=${detail.months}&bonus=0&codice_cliente=${customerCode}&rateizza=${rateizza}`;
      const urlPrenota = `https://my.revoluce.it/area_utente/gestione/api/promo/prenota3612.php?customer_id=${customerId}&customer_code=${customerCode}&tkn_pvt=${tkn}&pod_code=${podCode}&importo=${parseFloat(
        detail.price
      ).toFixed(2)}&tipo=${detail.months}`;
        const urlPrenotaR = `https://my.revoluce.it/area_utente/gestione/api/promo/prenota3612r.php?customer_id=${customerId}&customer_code=${customerCode}&tkn_pvt=${tkn}&pod_code=${podCode}&importo=${parseFloat(
        detail.price
      ).toFixed(2)}&tipo=${detail.months}`;
  
      
      const { data } = await axios.get(
        defaultMethod === "RID" && !rateizza
          ? urlPrenota
          : defaultMethod === "RID" && rateizza
          ? urlPrenotaR
          : defaultMethod !== "RID" && rateizza 
          ? urlPrenotaR 
          : urlPaga
      );
      if (data.success) {
        navigate("/enrica/richiesta-inoltrata");
      } else {
        navigate("/enrica/errore");
      }
    } else if(token && !prenotazioneEffettuata){ //seconda opzione
      dispatch(setPath(location.pathname));
      setDisable(!disable)
      setSeeConferma(false)
      const urlPaga = `https://my.revoluce.it/sella/pagaPromoApp.php?amount=${
        rateizza
          ? parseFloat(detail.price / detail.diviso).toFixed(2)
          : parseFloat(detail.price).toFixed(2)
      }&token=${token}&customer=${customerId}&tipo=${detail.months}&bonus=0&codice_cliente=${customerCode}&rateizza=${rateizza}`;
      const urlPrenota = `https://my.revoluce.it/area_utente/gestione/api/promo/prenota3612.php?customer_id=${customerId}&customer_code=${customerCode}&tkn_pvt=${tkn}&pod_code=${podCode}&importo=${parseFloat(
        detail.price
      ).toFixed(2)}&tipo=${detail.months}`;
        const urlPrenotaR = `https://my.revoluce.it/area_utente/gestione/api/promo/prenota3612r.php?customer_id=${customerId}&customer_code=${customerCode}&tkn_pvt=${tkn}&pod_code=${podCode}&importo=${parseFloat(
        detail.price
      ).toFixed(2)}&tipo=${detail.months}`;
  
    
  
      const { data } = await axios.get(
        defaultMethod === "RID" && !rateizza
          ? urlPrenota
          : defaultMethod === "RID" && rateizza
          ? urlPrenotaR
          : defaultMethod !== "RID" && rateizza 
          ? urlPrenotaR 
          : urlPaga
      );
      if (data.success) {
        navigate("/enrica/richiesta-inoltrata");
      } else {
        navigate("/enrica/errore");
      }
    } else { //ultima opzione
      return;
    }
  };

  return (
    <div className="promo">
      {seeConferma && <Conferma setSeeConferma={setSeeConferma} mainFunction={payPromo}/>}
      <div className="promo-top">
        <NewHeader title="Ricarica 3-6-12" iconsColor="white" />
      </div>
      {overlay ? (
        <div className="promo-bottom overlay" style={prenotazioneEffettuata ? {padding: '0px'} : null}>
            {prenotazioneEffettuata ? (
              <AlertNotice 
                seeClose={true} 
                title="Attendi per la prossima ricarica!" 
                paragraphOne="Recentemente hai già richiesto una Ricarica 3-6-12."
                paragraphTwo="Ti consigliamo di attendere prima di acquistarne un'altra. Non preoccuparti! Siamo continuamente alla ricerca di nuovi modi per farti risparmiare."
                shooFooter={true}
              />
                // <div className="notice" style={{borderTopRightRadius: '40px', borderTopLeftRadius: '40px'}}>
                // {/* <div className="close">
                //     <Close />
                // </div> */}
                // <div className="box">
                //     <div className="header">
                //     <Alert />
                //     <p>Attendi per la prossima ricarica!</p>
                //     </div>
                //     <div className="body">
                //         <p>Recentemente hai già richiesto una Ricarica 3-6-12.</p>
                //     <p style={{ marginTop: "15px" }}>
                //         Ti consigliamo di attendere prima di acquistarne un'altra.
                //     </p>
                //     <p style={{ marginTop: "15px" }}>
                //         Non preoccuparti! <br/>
                //         Siamo continuamente alla ricerca di nuovi modi per farti risparmiare.
                //     </p>
                //     </div>
                // </div>
                // </div>
            ) : null}
          <div className="main-top">
            <p className="main">Ricarica {detail.months}</p>
            <div className="icon">
              {detail.icon}
            </div>
          </div>
          <div className="main-bottom">
            <p className="conferma">Conferma la richiesta</p>
            <p className="secondary">
              Ricarica subito{" "}
              {parseFloat(detail.price).toFixed(2).replace(/\./g, ",")} €,
              l'equivalente di {detail.months} mesi di consumo (calcolati sullo
              storico dei tuoi consumi) ed otterrai subito un bonus pari al{" "}
              {rateizza
                ? Math.floor(detail.bonusPercentualeRatio * 100)
                : Math.floor(detail.bonusPercentuale * 100)}{" "}
              % dell'importo ricaricato.
            </p>
          </div>
          <div className="listBox">
            <div className="box">
              <div className="col">
                <p className="label">Il tuo bonus</p>
                {rateizza ? (
                  // console.log(parseFloat(detail.price).toFixed(2))
                  <p className="main">
                    {parseFloat(parseFloat(detail.price) * parseFloat(detail.bonusPercentualeRatio)).toFixed(2).replace(/\./g, ",")}
                  </p>
                ) : (
                  <p className="main">
                    {parseFloat(parseFloat(detail.price) * parseFloat(detail.bonusPercentuale)).toFixed(2).replace(/\./g, ",")}
                  </p>
                )}
              </div>
              {rateizza && <Alert fill="red" />}
            </div>
            <div className="empty"></div>
            <div className="box">
              <div className="col">
                <p className="label">Pari al</p>
                <p className="main">
                  {rateizza
                    ? Math.floor(detail.bonusPercentualeRatio * 100)
                    : Math.floor(detail.bonusPercentuale * 100)}{" "}
                  %
                </p>
              </div>
              <p className="secondary">Dell'importo ricaricato</p>
            </div>
          </div>
          {rateizza && (
            <p className="warning">
              Se scegli di pagare a rate la percentuale di bonus diminuisce. Se
              vuoi garantirti il massimo del bonus, paga subito l'intero
              importo.
            </p>
          )}
          <PayMethod />
          {/* {detail.rateizzabile && (
            <div className="rateizzabileCheck">
              <div className="rateiBox">
                <div className="icon" onClick={() => setRateizza(!rateizza)}>
                  <div className="checkbox">{rateizza ? <i></i> : null}</div>
                </div>
                <div className="info">
                  <p className="secondary">Paga in 5 rate</p>
                  <p className="description">
                    Spunta questa casella se vuoi pagare la tua ricarica a rate
                  </p>
                </div>
              </div>
            </div>
          )} */}

          {rateizza && (
            <div className="rateizzata">
              <p className="secondary">
                da pagare{" "}
                <span className="bold">
                  {parseFloat(detail.price).toFixed(2).replace(/\./g, ",")} €
                </span>{" "}
                in <span className="bold">{switchMonths()}</span> rate
              </p>
            </div>
          )}
          <div className="riepilogo">
            <p className="secondary">
              {rateizza ? "Prima rata" : "Ricarica di"}
            </p>
            <p className="main">
              {rateizza
                ? parseFloat(parseFloat(detail.price) / detail.diviso)
                    .toFixed(2)
                    .replace(/\./g, ",")
                : parseFloat(detail.price).toFixed(2).replace(/\./g, ",")}{" "}
              €
            </p>
          </div>
          {/* {detail.rateizzabile ? null : (
            <div className="rateizzabile">
              <div className="icon">
                <Close fill="red" />
              </div>
              <p className="main">Pagamento a rate</p>
            </div>
          )} */}
          {defaultMethod !== "RID" && !token && (
            <div
              className="aggiungiMetodo"
              onClick={() => navigate("/enrica/profilo/aggiungi")}
            >
              <p className="main">Aggiungi un metodo di pagamento</p>
              <div className="circle">
                <Plus />
              </div>
            </div>
          )}
          <div className="buttons">
            <div className="button red" onClick={() => handleDetail()}>
              <p>Annulla</p>
              <Close fill="white" />
            </div>
            <div className="empty"></div>
            <div
              className={`button ${
                defaultMethod === "RID" && !prenotazioneEffettuata
                  ? "green"
                  : token && !prenotazioneEffettuata
                  ? "green"
                  : "gray"
              }`}
              onClick={() => !disable ? setSeeConferma(!seeConferma) : null }
            > { !disable ? (
              <>
                <p>{defaultMethod === "RID" ? "Prenota" : "Acquista" }</p>
                <Check fill="white" />
              </>
            ) : <CircularProgress />}
            </div>
          </div>
          <div className="emptyBox" style={{height: '100px'}}></div>

        </div>
      ) : (
        <div className="promo-bottom" style={!priceDecimal3 || !priceDecimal6 || !priceDecimal12 ? {padding: '0px'} : null}>
          {!priceDecimal3 || !priceDecimal6 || !priceDecimal12 ? (
            <AlertNotice 
              shooFooter={true} 
              seeClose={true} 
              title="Non è possibile procedere con la ricarica." 
              paragraphOne="Purtroppo non abbiamo abbastanza dati a disposizione per il calcolo automatico delle taglie."
              paragraphTwo="Se sei interessato e vuoi sapere come fare per conoscere la taglia adatta a te inviaci una mail a info@revoluce.it o inviaci un messaggio su WhatsApp al 393-5777481."
            />
          ) : null}
          <div className="text">
            <p className="title">Ricarica 3-6-12</p>
            <p className="secondary">
              Scegli di pagare in anticipo 3, 6 o 12 mesi di consumo (calcolati
              sullo storico dei tuoi consumi) ed ottieni subito fino al 30% di
              bonus.
            </p>
            <p className="secondary">
              Puoi acquistare anche più ricariche per aumentare il risparmio.
            </p>
            {/* <div className="claim">
              <Check />
              <p className="secondary">
                Paga le ricariche 6 e 12 in comode rate!
              </p>
            </div> */}
          </div>
          <div className="items">
            {data.map((r, i) => (
              <div className="item" key={i} onClick={() => r.price && r.price ? handleDetail(r) : null}>
                {/* {r.rateizzabile && (
                  <div className="rateizzabile">
                    <div className="box">
                      <p>Paga a rate</p>
                      <div className="circle">
                        <Check />
                      </div>
                    </div>
                  </div>
                )} */}
                <div className="item-top">
                  <div className="item-top_icon">
                    {r.icon}
                  </div>
                  <div className="item-top_text">
                    <p className="main">Ricarica {r.months}</p>
                  </div>
                  <div className="item-top_arrow">
                    <ArrowForwardIosIcon />
                  </div>
                </div>
                <div className="item-bottom">
                  <div className="item-bottom_box">
                    <p className="label">Se ricarichi</p>
                    <p className="main">{r.price && r.price[0] || 0}, <span className="decimal">{r.price && r.price[1] || 0}€</span></p>
                  </div>
                  <div className="item-bottom_box bonus">
                    <p className="label">Bonus di</p>
                    <p className="main">{r.price && parseFloat(parseFloat(r.price) * parseFloat(r.bonusPercentuale)).toFixed(2).replace(/\./g, ",") || 0} €</p>
                  </div>
                </div>
              </div>
            ))}
            
          </div>
          <div className="emptyBox" style={{height: '100px'}}></div>

        </div>
      )}
    </div>
  );
}

export default Promo;
